import { VueCookieNext } from 'vue-cookie-next'

export default class ApiService {
    static base_url = process.env.VUE_APP_BASE_URL
    static base_url2 = process.env.VUE_APP_BASE_URL2
    static user = VueCookieNext.getCookie('x-user-token')
    // static user = "09211967134"
    // static token = "12345"
    static token = VueCookieNext.getCookie('x-access-token')
}